var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.406 6.844l-8.625 10.78a1 1 0 01-1.38.176l-4.8-3.6 1.2-1.6 4.024 3.018 8.019-10.024 1.562 1.25z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE5LjQwNTcgNi44NDM2M0wxMC43ODEgMTcuNjI0NUMxMC40NDM2IDE4LjA0NjMgOS44MzIyIDE4LjEyMzkgOS40MDAxIDE3Ljc5OThMNC42MDAxIDE0LjE5OThMNS44MDAxIDEyLjU5OThMOS44MjQ3MSAxNS42MTgzTDE3Ljg0MzkgNS41OTQyNEwxOS40MDU3IDYuODQzNjNaIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC45Ii8+Cjwvc3ZnPg==";
export { SvgCheckmark as ReactComponent };